export default __webpack_public_path__ + "static/media/bike_preloader.2b882544.gif";